import React, { useState,useContext } from 'react';
import { FilenameContext } from './FilenameContext';
const DownloadButton = ({token, fileName}) => {
    const [loading, setLoading] = useState(false);
   
    const buttonStyle = {
        display: 'inline-block',
       
        textDecoration: 'none',

        background: '#668ad8', // ボタン色
        color: '#FFF',
        borderBottom: 'solid 4px #627295',
        borderRadius: '20px',
        animation: 'blink 1s infinite',
        fontSize: 'large',
        fontFamily: 'auto'
    };
    const handleDownload = async () => {
        setLoading(true);
        try {
            // Flaskのエンドポイントから有効期限付きURLを取得
            const response = await fetch(`${process.env.REACT_APP_URL}/api/file_download/${token}`);
            console.log("URL:", response);
            // ステータスコードが404の場合、エラーメッセージを表示
            if (!response.ok) {
                if (response.status === 404) {
                    alert("File not found. The URL may be invalid or out of date.");
                } else {
                    alert(`An error has occurred: ${response.statusText}`);
                }
                console.error("Error fetching download URL:", response.statusText);
                return;
            }

            // ダウンロードURLを取得
            const downloadUrl = response.url;
            

            // ダウンロード用のリンクをクリック
            const anchor = document.createElement('a');
            anchor.href = downloadUrl;
            anchor.download = fileName;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        } catch (error) {
            console.error('Error fetching download URL:', error);
            alert("An error has occurred");
        } finally {
            setLoading(false);
        }
        
        
        

        
    };

    return (
        <div>
            <button
                style={{
                    ...buttonStyle
                }}
                
                onClick={handleDownload} disabled={loading}>
                {loading ? 'Generating URL...' : 'Download'}
            </button>
        </div>
    );
};

export default DownloadButton;
